<template>
  <div class="work-con">
    <div class="pc-show" v-if="!isPhone">
      <div class="teaching-details-work">
        <div class="teacher-details-top">
          <span @click="goHome">首页 &nbsp;>&nbsp;</span>
          <span @click="goTealist">教材中心&nbsp;>&nbsp;</span>
          <span @click="goDetail">教材详情&nbsp;>&nbsp;</span>
          <span style="color:#027B52">目录</span>
        </div>
        <div class="teacher-details-middle clearfix">
          <div class="teacher-details-right">
            <div class="teacher-details clearfix">
              <div class="rigth-top clearfix">
                <p class="title-file-top">资源介绍</p>
                <span class="sp-button-fanhui-pc" @click="goDetail">返回</span>
              </div>
              
              <div class="source-info-text">
                <p>所属课程：<span>{{ data.bookInfo.courseName }}</span></p>
                <!-- <span>资源作者：<span>{{ data.bookInfo.auth }}</span></p> -->
                <!-- <p>资源种类：<span>{{ data.bookInfo.type }}</span></p> -->
                <p>上传时间：<span>{{ data.bookInfo.dateTime }}</span></p>
                <p>浏览数：<span>{{ data.bookInfo.viewCount }}</span></p>
              </div>
              <div class="catalo-work-one-right">
                <!-- <img :src="workImg" alt="" /> -->
                <qrcode-vue :value="value" :size="150" level="H" />
                <p>手机扫一扫，即可浏览</p>
              </div>
            </div>
          
          </div>
          <div class="teacher-details-left">
            <!-- 作业测验 -->
            <Work :data="data" :courseId="data.bookInfo.courseId" v-if="(data.bookInfo.cellType==5 || data.bookInfo.cellType==6) && data.bookInfo.paperType!=4"></Work>
            <!-- 问卷调查 -->
            <questionnaire :data="data" :courseId="data.bookInfo.courseId" v-if="data.bookInfo.cellType==9"></questionnaire>
            <!-- 预览 -->
            <div class="preparing-course-ware" v-if="data.bookInfo.cellType==1">
              <PreparingCourseware v-if="dialogVisiblePreviewResources"
                  :sourceId="data.courseware.Id"
                  :bottommenu="true"
                  :courseId="data.bookInfo.courseId"
                  :savesession="false"
                  @dialogVisiblePreviewResources="closeSource"
                  :fileList=[]></PreparingCourseware>
            </div>
            <!-- 头脑风暴 -->
            <div class="course-text-interact" v-if="data.bookInfo.cellType==11">
              <div class="course-interact-hader clearfix">
                <p class="title-file-top">名称：{{data.activtyInfo.ActivityName}}</p>
                <span class="sp-button-fanhui" @click="goDetail">返回</span>
              </div>
              <div class="course-interact-back">
                <p v-html="data.activtyInfo.ActivityContent"></p>
                <img :src="data.activtyInfo.CreateAvatorUrl" alt="">
              </div>
            </div>
            <!-- 投票 -->
            <div class="course-text-interact" v-if="data.bookInfo.cellType==7">
              <div class="course-interact-hader clearfix">
                <p class="title-file-top">名称：{{data.activtyInfo.ActivityName}}</p>
                <span class="sp-button-fanhui" @click="goDetail">返回</span>
              </div>
              <div class="course-interact-back">
                <el-form label-width="140px">
                  <div style="padding-bottom:15px;">{{data.activtyInfo.ActivityContent}}</div>
                  <el-radio-group v-show="data.activtyInfo.VoteType == 1|| data.activtyInfo.VoteType==0">
                    <el-radio label="1">正确</el-radio>
                    <el-radio label="2">错误</el-radio>
                  </el-radio-group>
                  <el-radio-group v-show="data.activtyInfo.VoteType == 2">
                    <el-radio label="1">赞成</el-radio>
                    <el-radio label="2">反对</el-radio>
                  </el-radio-group>
                  <el-radio-group v-show="data.activtyInfo.VoteType == 3">
                    <div v-for="(li,index) in data.activtyInfo.DataJson"
                        :key="index"
                        style="line-height:40px;"
                        class="yk-part-vote-s-wrapper">
                      <el-radio :label="li.name">{{li.name}}: {{li.content}}</el-radio>
                    </div>
                  </el-radio-group>
                  <el-checkbox-group>
                    <div v-show="data.activtyInfo.voteType == 4"
                        v-for="(li,index) in data.activtyInfo.DataJson"
                        :key="index"
                        style="line-height:40px;">
                      <el-checkbox :label="li.name">{{li.name}}: {{li.content}}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                  <el-form-item>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <!-- 讨论 -->
            <div class="course-text-interact" v-if="data.bookInfo.cellType==8">
              <div class="course-interact-hader clearfix">
                <p class="title-file-top">名称：{{data.activtyInfo.ActivityName}}</p>
                <span class="sp-button-fanhui" @click="goDetail">返回</span>
              </div>
              <div class="course-interact-back"> 
                <p v-html="data.activtyInfo.ActivityContent"></p>
                <img :src="data.activtyInfo.CreateAvatorUrl" alt="">
              </div>
            </div>
            <!-- 提问 -->
            <div class="course-text-interact" v-if="data.bookInfo.cellType==10">
              <div class="course-interact-hader clearfix">
                <p class="title-file-top">名称：{{data.activtyInfo.ActivityName}}</p>
                <span class="sp-button-fanhui" @click="goDetail">返回</span>
              </div>
              <div class="course-interact-back">
                <p v-html="data.activtyInfo.ActivityContent"></p>
              </div>
            </div>
            <!--附件作业-->
            <div class="course-text-interact" v-if="data.bookInfo.paperType==4">
              <div class="course-interact-hader clearfix">
                <p class="title-file-top">名称：{{questionTitle}}</p>
              </div>
              <div class="course-interact-back clearfix">
                <el-form :model="content">
                  <el-form-item>
                    <label class="yk-ap-que-name" style="width:60px;">内容:</label><span v-html="data.info.Descriptioin"></span>
                  </el-form-item>
                  <el-form-item>
                    <label class="yk-ap-que-name">附件: </label>
                    <div v-for="(item,index2) in data.info.FileList" :key="index2" :index="index2" class="yk-img-left" @click="lookImg(item.Id)">
                      <img v-if="item.DocExtension!='.mp4'" :src="item.DocPrexUrl || item.DocUrl" class="encl-img-cover" />
                      <img v-if="item.DocExtension=='.mp4'" :src="item.DocUrl+'?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160'" class="encl-img-cover" />
                      <p class="p-title-name">{{item.DocTitle}}</p>
                    </div>
                  </el-form-item> 
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="phone-show" v-if="isPhone">
      <div class="teaching-details-work">
        <div class="teacher-details-middle clearfix">
          <div class="hader-text-top clearfix">
            <p class="p-hader-top">{{questionTitle || data.title}}</p>
            <span class="sp-button-back" @click="goBook()">返回</span>
          </div>
          <div class="resource-details">
            <!-- 作业测验 -->
            <phoneWork
              :data="data"
              :courseId="data.bookInfo.courseId"
              v-if="(data.bookInfo.cellType==5 || data.bookInfo.cellType==6) && data.bookInfo.paperType!=4"
            ></phoneWork>
            <!-- 问卷调查 -->
            <phoneQuestionnaire
              :data="data"
              :courseId="data.bookInfo.courseId"
              v-if="data.bookInfo.cellType==9"
            ></phoneQuestionnaire>
            <!-- 预览 -->
            <div class="preparing-course-ware" v-if="data.bookInfo.cellType==1">
              <phonePreparingCourseware
                v-if="dialogVisiblePreviewResources"
                :sourceId="data.courseware.Id"
                :bottommenu="true"
                :courseId="data.bookInfo.courseId"
                :savesession="false"
                @dialogVisiblePreviewResources="closeSource"
                :fileList="[]"
              ></phonePreparingCourseware>
            </div>
            <!-- 头脑风暴 -->
            <div class="course-text-interact" v-if="data.bookInfo.cellType==11">
              <div class="course-interact-back">
                <p v-html="data.activtyInfo.ActivityContent"></p>
                <img :src="data.activtyInfo.CreateAvatorUrl" alt />
              </div>
            </div>
            <!-- 投票 -->
            <div class="course-text-interact" v-if="data.bookInfo.cellType==7">
              <div class="course-interact-back">
                <el-form label-width="140px">
                  <div style="padding-bottom:15px;">{{data.activtyInfo.ActivityContent}}</div>
                  <el-radio-group
                    v-show="data.activtyInfo.VoteType == 1|| data.activtyInfo.VoteType==0"
                  >
                    <el-radio label="1">正确</el-radio>
                    <el-radio label="2">错误</el-radio>
                  </el-radio-group>
                  <el-radio-group v-show="data.activtyInfo.VoteType == 2">
                    <el-radio label="1">赞成</el-radio>
                    <el-radio label="2">反对</el-radio>
                  </el-radio-group>
                  <el-radio-group v-show="data.activtyInfo.VoteType == 3">
                    <div
                      v-for="(li,index) in data.activtyInfo.DataJson"
                      :key="index"
                      style="line-height:40px;"
                      class="yk-part-vote-s-wrapper"
                    >
                      <el-radio :label="li.name">{{li.name}}: {{li.content}}</el-radio>
                    </div>
                  </el-radio-group>
                  <el-checkbox-group>
                    <div
                      v-show="data.activtyInfo.voteType == 4"
                      v-for="(li,index) in data.activtyInfo.DataJson"
                      :key="index"
                      style="line-height:40px;"
                    >
                      <el-checkbox :label="li.name">{{li.name}}: {{li.content}}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                  <el-form-item></el-form-item>
                </el-form>
              </div>
            </div>
            <!-- 讨论 -->
            <div class="course-text-interact" v-if="data.bookInfo.cellType==8">
              <div class="course-interact-back">
                <p v-html="data.activtyInfo.ActivityContent"></p>
                <img :src="data.activtyInfo.CreateAvatorUrl" alt />
              </div>
            </div>
            <!-- 提问 -->
            <div class="course-text-interact" v-if="data.bookInfo.cellType==10">
              <div class="course-interact-back">
                <p v-html="data.activtyInfo.ActivityContent"></p>
              </div>
            </div>
            <!--附件作业-->
             <div class="course-text-interact" v-if="data.bookInfo.paperType==4">
              <div class="course-interact-back clearfix">
                <!-- <p v-html="data.info.Descriptioin"></p>
                <div v-for="(item,index) in data.info.FileList" :key="index" class="enclosure-img-left">
                  <img :src="item.DocUrl" @click="lookImg(item.DocUrl)"/>
                </div> -->
                <el-form :model="content">
                  <el-form-item>
                    <label class="yk-ap-que-name" style="width:60px;">内容:</label><span v-html="data.info.Descriptioin"></span>
                  </el-form-item>
                  <el-form-item>
                    <label class="yk-ap-que-name">附件: </label>
                    <div class="file-left-center">
                      <div v-for="(item,index2) in data.info.FileList" :key="index2" class="yk-img-left" @click="lookImg(item.Id)">
                        <img v-if="DocExtension!='.mp4'" :src="item.DocPrexUrl || item.DocUrl" class="encl-img-cover" />
                      <img v-if="DocExtension=='.mp4'" :src="item.DocPrexUrl+'?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160' || item.DocUrl" class="encl-img-cover" />
                        <p class="p-title-name">{{item.DocTitle}}</p>
                      </div>
                    </div>
                  </el-form-item> 
                </el-form>
              </div>
            </div>
            <!-- <discussion></discussion> -->
          </div>
        </div>
      </div>
    </div>
     <!-- 文件预览 -->
    <div class="yk-source-previewResourcces-main"
         v-show="dialogPreviewResources">
        <!-- <i @click="dialogClose()"
         style="color:red;position: fixed;right: 4.5%;font-size: 40px;bottom: 0;"
         class="el-icon-close yl-source-preview-show-close-wrapper "></i> -->
      <Preparingfile v-if="dialogPreviewResources"
                           :sourceId="sourceId"
                           @dialogVisiblePreviewResources="dialogClose()"></Preparingfile>
    </div>
  </div>
  
</template>
<script>
import QrcodeVue from "qrcode.vue";
import Work from "components/catalo/work.vue";
import questionnaire from "components/catalo/questionnaire.vue";
import discussion from "components/catalo/discussion.vue";
import PreparingCourseware from "components/MaterialCenter/PreparingCoursewareBook.vue";
import Preparingfile from "components/PreparingCourseware.vue";

// 手机端组件适配
import phoneWork from "components/catalo/phoneWork.vue";
import phoneQuestionnaire from "components/catalo/phoneQuestionnaire.vue";
import phoneDiscussion from "components/catalo/phoneDiscussion.vue";
import phonePreparingCourseware from "../../components/MaterialCenter/phonePreparingCoursewareBook ";
import { debug } from 'util';
import { constants } from 'fs';

export default {
  components: {
    Work,
    discussion,
    questionnaire,
    PreparingCourseware,
    QrcodeVue,
    Preparingfile,
    phoneDiscussion,
    phoneQuestionnaire,
    phoneWork,
    phonePreparingCourseware
  },
  data() {
    return {
      dialogPreviewResources: false,
      content:{},
      imgurl:"",
      isShow: false,
      options: {
        inline: true,
        button: false,
        navbar: false,
        toolbar: false,
        title: false
      },
      value:"",
      size:0,
      screenWidth: document.body.clientWidth,
      workImg: require("assets/images/login.png"),
      data:{
        bookInfo:{}
      },
      dialogVisiblePreviewResources: true,
      sourceId:'yf4layiqtovlegyy1xc76q',
      courseId:'',
      fileList: [],
      voteInfo:{
        ActivityContent: "淘汰",
        ActivityName: "2018-09-07 14:19:12的投票44444444444444444",
        DataJson: "",
        DocJson: "http://file.chinahoteledu.com/66ykt/ori/-qcyafcp75ndb42qoorwga/Fn4ijJ4AXnr6ztmn.png",
        VoteType: 2,
      },
      activtyInfo:{
        ActivityContent: "123",
        ActivityName: "2018-09-07 14:34:19的头脑风暴",
        ActivityRemake: "",
        ActivityState: 0,
        ActivityType: 2,
        ClassState: 0,
        CourseId: "2l-lafcpqojgfauwv9-j1q",
        CourseName: "机械基础",
        CreateAvatorUrl: "http://file.chinahoteledu.com/66ykt/ori/-qcyafcp75ndb42qoorwga/rnEYR5YmkcJaDrPt.jpg",
        CreateDisplayName: "shen",
      },
      questionTitle: "",
      isPhone:false,
      enclosure:{}
    }
  },
  props: {
    resId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getCellInfo();
    this.getValue();
    if (this.screenWidth < 800) {
      this.isPhone = true;
    }else{
      this.isPhone = false;
    }
  },
  beforeCreate() {
    document.title = "";
  },
  methods:{
    dialogClose() {
      this.dialogPreviewResources = false;
    },
    lookImg(id){
      this.sourceId = id;
      this.dialogPreviewResources = true;
    },
    getValue() {
      this.value = "http://47.103.188.161/kdx/"+this.resId+"/bookDetail";
      this.size = this.screenWidth * 0.1;
    },
    goHome(){
      this.$router.push({
        name:"xHome"
      })
    },
    goTealist(){
      this.$router.push({
        name:"teachingMaterial"
      })
    },
    goDetail(){
      this.$router.push({
        name:"teachingDetails",
        params: {
          bookId: this.data.bookInfo.courseId
        }
      })
    },
    goBook(){
      this.$router.push({
        name:'teachingDetails',
         params: {
          bookId: this.data.bookInfo.courseId
        }
      })
    },
    getCellInfo() {
      var self = this;
      this.$http.post("/api/XOrg/TextBookSourceInfo/getCellInfo", {
        cellId: self.resId
      }).then(function(res) {
        if(res.code>0){
          self.data=res;
          if(res.paperName) {
            self.questionTitle = res.paperName;
            if(window.innerWidth<960){
              document.title = res.paperName;
            }else{
              document.title = "1+X试点";
            }
          } else if (res.courseware) {
            self.questionTitle  =  res.courseware.CourseWareName;
            if(window.innerWidth<960){
              document.title = res.courseware.CourseWareName;
            }else{
              document.title = "1+X试点";
            }
          } else if (res.activtyInfo) {
            if(window.innerWidth<960){
              document.title = res.activtyInfo.ActivityName;
            }else{
              document.title = "1+X试点";
            }
            self.questionTitle = res.activtyInfo.ActivityName;
          } else if(res.info){
            self.questionTitle=res.info.Title;
            if(window.innerWidth<960){
              document.title = res.courseware.CourseWareName;
            }else{
              document.title = "1+X试点";
            }
          }
        }else{
          self.$message.warning(res.msg);
        }
      });
    },
    closeSource(isDialog){
			this.dialogVisiblePreviewResources = isDialog;
		},
  }
};
</script>
<style lang='scss'>
.work-con {
  height: 100%;
  .pc-show{
    display: block;
    .teaching-details-work {
      margin: 0 auto 50px;
      width: 1200px;
      .teacher-details-top {
        height: 50px;
        line-height: 50px;
      }
      .work-details-content {
        margin: 27px 31px 0 31px;
        // width: 886px;
        height: 340px;
        background: rgba(248, 249, 250, 1);
        .work-content-item {
          padding-top: 32px;
          margin-left: 20px;
          .span-item {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            height: 24px;
            line-height: 24px;
            background: rgba(255, 154, 160, 1);
            border-radius: 12px;
            margin-right: 31px;
            padding: 0 5px;
          }
          .span-wenzi {
            font-size: 14px;
            margin-left: 10px;
          }
          .span-shuoming {
            height: 40px;
          }
          .check-item {
            margin-right: 60px;
          }
        }
      }
      .teacher-details-middle {
        .fan-hui-button{
          display: none;
        }
        .work-name-detail {
          .work-name-fr {
            width: 600px;
            margin: 27px 31px 0 31px;
            .name-li {
              width: 260px;
              padding: 10px 10px 20px 10px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 24px;
            }
          }
        }
        .teacher-details-right {
          background: #ffffff;
          width: 100%;
          // height: 670px;
          .teacher-details {
            padding: 20px;
          }
          .rigth-top {
            background: #05243D;
            height: 42px;
            font-size: 16px;
            font-weight: bold;
            color: #ffffff;
            line-height: 42px;
            padding-left: 20px;
            padding-right: 20px;
          }
          .work-book-details {
            margin: 0 auto;
            margin-top: 45px;
          }
          .book-img-fl {
            margin-left: 10px;
            width: 91px;
            height: 127px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(223, 226, 230, 1);
          }
          .book-zuozhe {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            padding-bottom: 10px;
          }
          .book-content-fr {
            margin-right: 6px;
          }
          .book-name {
            font-size: 14px;
            font-family: MicrosoftYaHei-Bold;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 20px;
          }
        }
        .teacher-details-left {
          background: #ffffff;
          width: 100%;
          min-height: 630px;
          padding: 20px;
          box-sizing: border-box;
        }
        .work-fl {
          .span-date {
            padding-left: 20px;
          }
        }
        .work-fr {
          .span-leixing {
            height: 4px;
            width: 1px;
            color: #fff;
            padding-right: 8px;
          }
          .span-leixing:nth-child(1) {
            border-right: 2px solid #ffffff;
            margin-right: 9px;
          }
        }
      }
      .preparing-course-ware{
        width: 100%;
        height: 900px;
      }
      .source-info-text{
        padding: 20px;
        float: left;
        width: 50%;
        p{
          font-size: 16px;
          font-weight: 600;
          color: #000;
          line-height: 60px;
        }
        span{
          font-weight: 400;
          font-size: 14px;
        }
      }
      .catalo-work-one-right{
        float: left;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #000;
        padding: 20px;
        img{
          width: 250px;
          height: 250px;
        }
      }
      .course-text-interact{
      }
      .course-interact-hader{
          margin-bottom: 20px;
          height: 42px;
          padding: 0px 20px;
          line-height: 42px;
          background: #5c9eff;
          font-size: 16px;
          color: #fff;
          font-weight: bold;

        }
        .title-file-top{
          float: left;
          width: 80%;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        .sp-button-fanhui{
          float: right;
          cursor: pointer;
        }
        .sp-button-fanhui-pc{
          float: right;
          cursor: pointer;
        }
        .sp-button-fanhui{
          display: none;
        }
    }
    .course-interact-back{
      background: #f5f5f5;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      border-radius: 10px;
      min-height: 300px;
      padding: 15px 20px;
      .enclosure-img-left{
        height: 120px;
        width: 200px;
        float: left;
        margin-right: 10px;
        img{
          height: 100%;
          width: 100%;
        }
      }
    }
  }
  .phone-show {
    display: none;
    .top-book-info {
      background: #5c9eff;
      color: #fff;
      padding: 10px;
      height: 300px;
      border-radius: 0 0 8% 5%;
      i {
        position: relative;
        top: -4px;
        font-size: 25px;
      }
      .top-title {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-weight: 500;
        .header-title {
          margin-left: 50px;
          display: inline-block;
          width: 220px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .resource-intro-title-con {
        text-align: center;
        padding: 20px 0;
        .title-file-top {
          padding: 5px 15px;
          display: inline-block;
          background: #2d82ff;
          border-radius: 22px;
          font-size: 14px;
          font-weight: 700;
        }
      }
      .source-info-text {
        line-height: 30px;
        padding-left: 20px;
      }
    }
    .resource-details {
      position: relative;
      top: -55px;
      padding: 0 15px;
      // background: #fff;
    }
    .course-text-interact {
      background: #fff;
      padding: 10px;
      border-radius: 10px;
      min-height: 200px;
    }
    .preparing-course-ware {
        width: 100%;
        height: 520px;
        // height: 300px !important;
    }
    .course-interact-back{
      background: #f5f5f5;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      border-radius: 10px;
      min-height: 300px;
      padding: 10px 10px;
      .enclosure-img-left{
        height: 80px;
        width: 120px;
        float: left;
        margin-right: 10px;
        img{
          height: 100%;
          width: 100%;
        }
      }
    }
  }
  .preview-img-center{
    height: 100%;
    width: 100%;
    z-index: 9999;
    position: fixed;
    top: 0;
    background: rgba(0,0,0,.7);
    -webkit-transform: translateZ(0);
    .mongolia-img{
      position: relative;
      width: 100%;
      height: 100%;
    }
    .close-red{
      position: absolute;
      bottom: 0;
      right: 20px;
      color: red;
      font-weight: bold;
      font-size: 30px;
      cursor: pointer;
    }
  }
  .fr-wrapper {
    height: 180px;
    line-height: 20px;
  }
  .yk-ap-que-name {
    float: left;
    font-size: 18px;
    color: #333;
    width:50px;
  }
  .yk-ap-que-btn-back {
    float: right;
  }
  .yk-img-left{
    width: 200px;
    float: left;
    margin-right: 10px;
    text-align: center;
    cursor: pointer;
    .encl-img-cover{
      width: 100%;
      height: 120px;
    }
    .p-title-name{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
  .file-left-center{
    float: left;
    width: calc(100% - 50px);
  }
  .yk-source-previewResourcces-main {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.8);
  }
  // 移动端和PC端样式
  @media only screen and(max-width:960px) {
    /*当屏幕小于960px时，应用移动端的CSS样式*/
    .yk-source-previewResourcces-main {
      .PreviewRight{
        display: none;
      }
      .pptwidth{
        width: 100%;
      }
    }
    .pc-show {
      display: none;
    }
    .phone-show {
      height: 100%;
      width: 100%;
      position: fixed;
      top: 0;
      z-index: 9999;
      display: block;
      background: #ffffff;
      overflow: auto;
      .resource-details{
        top: 0;
        padding: 0;
        height: 100%;
        overflow-x: hidden;
        overflow-y: scroll;
      }
      .preparing-course-ware{
        height: 100%;
      }
    }
    .teaching-details-work{
      height: 100%;
    }
    .teacher-content-books .mincaclheight{
      height: 100%;
    }
    .teacher-details-middle{
      overflow: hidden;
      height: 100%;
    }
    .hader-text-top{
      height: 42px;
      background: #05243D;
      color: #fff;
      font-size: 16px;
      line-height: 42px;
      padding: 0 10px;
    }
    .p-hader-top{
      float: left;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      width: 80%;
    }
    .sp-button-back{
      float: right;
    }
    .teacher-content-books{
      .page-number-center{
        position: fixed;
        bottom: 10px;
      }
      .btn_pre-fd{
        right: 37%;
      }
      .btn_pre-sx{
        left: 37%;
      }
      .btn_pre-right{
        right: 27%;
      }
      .btn_pre-left{
        left: 27%;
      }
    } 
  }
}

</style> 